import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeStockReturnCreate } from '#/api/imsMgmt/receipts/stockReturn/serializeStockReturnWrite';

/** POST `/ims/stock-return`。不送 returnNo／sourceQty。 */
export async function createStockReturn(values) {
  const { data: raw } = await request.post(
    '/ims/stock-return',
    serializeStockReturnCreate(values),
  );
  return parseVer4DetailResponse(raw);
}
